export default "<div [class]=\"'alert alert-' + type\" role=\"alert\" style=\"display: block;\">\r\n  {{message}}\r\n</div> "